module.exports = __webpack_public_path__ + "images/directory/featured-hero/calendar@2x.230c74d098bfb71b1fd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/directory/featured-hero/calendar@2x.jpg
// module id = VZZb
// module chunks = 2